import { useMemo } from 'react'
import { LabeledOption } from '@e3dc-react/shell/Types'
import { ChargingSessionStatus } from '../types'
import { chargingSessionStatusTranslationKeys } from '../components/charging-session-status-translation-keys'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

/**
 * Hook to transform charging session statuses to the human readable statuses
 * It also transform and prepare statuses for filtering with label and value
 * It returns statuses sort by status name ascending
 */
export const useChargingSessionsStatus = (chargingSessionsStatuses: ChargingSessionStatus[]): LabeledOption<ChargingSessionStatus>[] => {
  const { t } = useCustomTranslation()

  const chargingSessionStatusOptions: LabeledOption<ChargingSessionStatus>[] = useMemo(
    () =>
      chargingSessionsStatuses
        .map(status => ({
          label: t(chargingSessionStatusTranslationKeys[status]),
          value: status,
        }))
        .sort((statusA, statusB) => statusA.label.localeCompare(statusB.label)),
    [chargingSessionsStatuses, t]
  )

  return chargingSessionStatusOptions
}
